import _ from "lodash";
import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { getRequestTypeTitle } from "helpers/RequestHelper";
import NoTableData from "components/NoTableData";

const LabListRow = ({ tableRows }) => {
  if (!tableRows) return null;

  if (_.isEmpty(tableRows)) {
    return <NoTableData />;
  }

  return _.map(tableRows, row => {
    const tn = row.formatedtransactionnumber;
    const requestType = getRequestTypeTitle(row.requesttypeid);

    return (
      <tr key={row.id}>
        <td>
          <Link to={`requests/${row.id}`}>{tn}</Link>
        </td>
        <td>{row.name}</td>
        <td>{row.modelnumber}</td>
        <td>{row.display}</td>
        <td>WINNF-TS-0122</td>
        <td>{requestType}</td>
        <td>{row.testingstatus}</td>
      </tr>
    );
  });
};

LabListRow.propTypes = {
  tableRows: PropTypes.array
};

export default LabListRow;



// WEBPACK FOOTER //
// ./src/components/labRequest/LabListRow.js